import {useRef} from 'react';

const DOUBLE_TAP_DELAY = 500;

// Touch double-tap detection for iOS. Uses touchend (fires reliably on every
// tap, even inside scroll containers where iOS swallows pointerup as
// pointercancel). preventDefault on the second tap suppresses the compat
// mouse events so a popup that closes on outside mouseup/click isn't shut by
// the tail of the opening gesture. Mouse double-click is handled separately
// via native onDoubleClick on the consumer.
function useDoubleTap(onDoubleTap?: () => void) {
    const lastTapRef = useRef<number | null>(null);

    return (event: React.TouchEvent) => {
        if(!onDoubleTap) return;
        const now = event.timeStamp;
        if(lastTapRef.current !== null && now - lastTapRef.current < DOUBLE_TAP_DELAY) {
            lastTapRef.current = null;
            event.preventDefault();
            onDoubleTap();
        } else {
            lastTapRef.current = now;
        }
    };
}

export default useDoubleTap;
